import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Field, reduxForm, formValueSelector } from 'redux-form';
import { TextField } from '../../../../components/fields';
import { required, minLength8, matchPasswords, password } from '../../../../utilities/validation';
import messages from '../../../../text/messages';
import { FormattedMessage } from 'react-intl';

class AcceptInvite extends React.Component {
    render() {
        const { handleSubmit, submitting } = this.props;

        return (
            <form onSubmit={handleSubmit}>
                <div className="row">
                    <div className="col-xs-12 col-sm-6">
                        <Field name="invitee_name" component={TextField} placeholder={messages.name} disabled />
                    </div>
                    <div className="col-xs-12 col-sm-6">
                        <Field name="email" validate={[required]} component={TextField} placeholder={messages.email} disabled />
                    </div>
                </div>
                <div className="ignored-password">
                    <Field
                        name="newPassword"
                        id="accept-invite-password"
                        component={TextField}
                        validate={[required, minLength8, ...password]}
                        type="text"
                        placeholder={messages.setYourPassword}
                    />
                </div>
                {/* <Field
                    name="iAgreeToTerms"
                    component={CheckboxField}
                    checked={iAgreeToTerms === true}
                    validate={required}
                    placeholder={messages.iAgreeToTerms}
                /> */}

                <div className="form-group">
                    <button id="accept-invite-password-btn" type="submit" className="btn btn-success btn-block" disabled={submitting}>
                        <FormattedMessage {...messages.submit} />
                    </button>
                </div>
            </form>
        );
    }
}

AcceptInvite.defaultProps = {
    handleSubmit: undefined,
    submitting: false
};

AcceptInvite.propTypes = {
    handleSubmit: PropTypes.func.isRequired,
    submitting: PropTypes.bool
};

AcceptInvite = reduxForm({ form: 'accept-invite', destroyOnUnmount: true, validate: matchPasswords })(AcceptInvite);
AcceptInvite = connect(state => {
    const selector = formValueSelector('accept-invite');
    return {
        iAgreeToTerms: selector(state, 'iAgreeToTerms') && selector(state, 'iAgreeToTerms') === true
    };
})(AcceptInvite);

export default AcceptInvite;



// WEBPACK FOOTER //
// ./src/pages/account/forms/acceptInvite/index.jsx